// extracted by mini-css-extract-plugin
module.exports = {"rightIcon":"index-module_rightIcon_1tdpu"};